import BaseStore from '../base-store'

let options = {}
export default new BaseStore('event-artists', options)



// WEBPACK FOOTER //
// ./src/store/modules/event-artist.store.js